export default __webpack_public_path__ + "static/media/strategicImg.e4702b96.png";